<template>
  <div v-if="!interactive" class="card theme-group-3">
    <slot></slot>
  </div>
  <button v-else-if="interactive && !to" class="card theme-group-3 card--interactive" @click="$emit('click')">
    <slot></slot>
  </button>
  <router-link v-else class="card theme-group-3 card--interactive" :to="to">
    <slot></slot>
  </router-link>
</template>

<script>
/**
 * This component represents a tile card and was built as an abstraction layer strategy.
 * The possibility of including a <div> <button> or <router-link> allows the component
 * to be more accessible depending it's role.
 *
 * @component
 * @example as <div>
 * <app-card> ... </app-card>
 *
 * @example as <button>
 * <app-card interactive @click="onClickHandler"> ... </app-card>
 *
 * @example as <router-link>
 * <app-card interactive :to="{ name: 'Menu' }"> ... </app-card>
 */
export default {
  name: "AppCard",
  props: {
    interactive: Boolean,
    to: [Object, String]
  }
};
</script>

<style scoped lang="scss">
.card {
  transition: background-color 0.5s;
  padding: ($spacer * 0.5);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  text-align: left;

  &--interactive {
    border: none;

    &:hover {
      cursor: pointer;
      background-color: $group-3-color-4-alpha-04;
    }

    &:active {
      transition: background-color 0s;
      cursor: pointer;
      background-color: rgba(black, 0.1);
      box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.12);
    }
  }
}
</style>
